$(function(){

    $('.jsPsychoCarousel').owlCarousel({
        loop: true,
        mouseDrag: false,
        touchDrag: false,
        animateOut: 'fadeOut',
        margin: 0,
        nav: true,
        dots: true,
        items: 1,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        navText: [
            '<svg class="icon-chevron-left-medium text-primary"><use xlink:href="#icon-chevron-left-light"></use></svg>',
            '<svg class="icon-chevron-right-medium text-primary"><use xlink:href="#icon-chevron-right-light"></use></svg>'
        ],
    });

});